module.exports = __webpack_public_path__ + "img/aus.cd4f8dfa.svg";